export type LoadingStage = 'auth' | 'config' | 'permissions' | 'ready';

const STAGE_CONFIG: Record<LoadingStage, { text: string; progress: number }> = {
  auth: { text: 'Authenticating...', progress: 25 },
  config: { text: 'Loading configuration...', progress: 55 },
  permissions: { text: 'Preparing interface...', progress: 80 },
  ready: { text: 'Almost ready...', progress: 95 },
};

export const AppFixedLoading = ({
  description,
  stage = 'auth',
}: {
  description?: string;
  stage?: LoadingStage;
}) => {
  const { text, progress } = STAGE_CONFIG[stage];
  const displayText = description || text;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 24,
        }}
      >
        <img
          src="/assets/images/logo-with-name.svg"
          alt="Nxsys"
          width={140}
          height={48}
        />

        {/* Progress bar */}
        <div
          style={{
            width: 200,
            height: 3,
            background: '#e8e8e8',
            borderRadius: 3,
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              width: `${progress}%`,
              height: '100%',
              background: '#00795B',
              borderRadius: 3,
              transition: 'width 0.6s ease-out',
            }}
          />
        </div>

        {/* Stage text */}
        <p
          key={displayText}
          style={{
            margin: 0,
            fontSize: 13,
            color: '#999',
            letterSpacing: 0.3,
            animation: 'splashFadeIn 0.3s ease-out',
          }}
        >
          {displayText}
        </p>
      </div>
    </div>
  );
};
